import {
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Options } from '@popperjs/core';
import { ButtonComponent } from '@shared/button/button.component';
import { ControlPopoverComponent } from '@shared/viewer/viewer-controls/control-popover/control-popover.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

/**
 * Displays additional information included on the Content Sheet for Viewer Assets using innerHTML.
 *
 * Will not display the section if Content Sheet doesn't have any additional info provided for the Asset.
 *
 * Displayed content is readonly.
 */
@Component({
  selector: 'zbp-viewer-additional-info',
  templateUrl: './viewer-additional-info.component.html',
  styleUrls: ['./viewer-additional-info.component.scss',],
  imports: [
    ButtonComponent,
    NgbPopover,
    ControlPopoverComponent,
  ]
})
export class ViewerAdditionalInfoComponent {
  isPopoverOpen = false;
  @Input() asset: ViewerAsset;
  @Input() isDesktop: boolean;

  @ViewChild('popoverControl') popoverControl!: ControlPopoverComponent;

  showPopover() {
    this.isPopoverOpen = true;
    this.popoverControl.onPopoverShown();
  }

  closePopover() {
    this.isPopoverOpen = false;
  }

  // Modifying Popper.js options
  popperOptions(options: Options): Options {
    return {
      ...options,
      strategy: 'absolute',
      modifiers: [
        ...(options.modifiers || []),
        {
          name: 'offset',
          options: {
            offset: [45, 0],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            // Allows popover to stay visible even when scrolled
            padding: 0,
          },
        },
      ],
    };
  }

  protected readonly zbpIconNames = zbpIconNames;
}
